export default "__VITE_ASSET__3b60050a__"